export default function DISPLAY({ children }) {
  return (
    <>
      <p>
        DISPLAY focuses on the experimental approach of Studio Juju exploring the idea of “display”
        in exhibition making.
      </p>
      <p>
        Using modest materials that are vernacular and tactile, the exploration strives to develop a
        display system that is structural and adaptable in supporting the display of various
        physical and visual contents. Through this exploration, Studio Juju will demonstrate the
        robust process and re-interpretations of DISPLAY, both as a sculptural object and a
        functional concept.
      </p>
      <p>
        The exhibition system developed is applied to three exhibitions in the BBB Design District:
        DESIGN at the National Design Centre, HEAL at 42 Waterloo, and PLANT at the National
        Library.
      </p>
      {children}
    </>
  );
}
